<div class="card w-full md:w-1/2 !mx-auto">
  <div class="card-body">
    @if (success === undefined) {
      <h2 class="text-xl text-center">Confirming your new email address...</h2>
    }
    @if (success) {
      <h2 class="text-xl text-center">Confirmed!</h2>
      <p>
        Your login email address has successfully been changed to:
        {{ newEmail }}.
        <br />
        You will be logged out now, please use this email address to log back in.
      </p>
    }
    @if (alreadyConfirmed) {
      <h2 class="text-center">Email Already Confirmed</h2>
      <p>Your login email address change has already been confirmed! You may continue to use your account normally.</p>
    }
    @if (success === false && !alreadyConfirmed) {
      <h2 class="text-xl font-bold text-center mb-4">Error!</h2>
      <p>Your confirmation key does not match your userId.</p>
      <p>If you have recently changed your email, please click the link sent to your new email address, to confirm your email.</p>
      <p>If you have requested an additional email, please make sure you are opening the most recent email from QualityBidders.</p>
      <p>If you contine to have issues, please contact Colbi support.</p>
    }
  </div>
</div>
